import React from 'react';
import { Table, LayoutGrid } from 'lucide-react';
import './ViewModeToggle.css';

export default function ViewModeToggle({ mode, onChange }) {
  return (
    <div className="view-mode-toggle">
      <button
        onClick={() => onChange('table')}
        className={`view-mode-toggle__button ${mode === 'table' ? 'active' : ''}`}
        aria-label="Visualizar como tabela"
      >
        <Table className="w-5 h-5" />
      </button>
      <button
        onClick={() => onChange('cards')}
        className={`view-mode-toggle__button ${mode === 'cards' ? 'active' : ''}`}
        aria-label="Visualizar como cards"
      >
        <LayoutGrid className="w-5 h-5" />
      </button>
    </div>
  );
}
